// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var ExpressionHelperUtilities = (function () {
    function ExpressionHelperUtilities() {
    }
    ExpressionHelperUtilities.prototype.getFilterExpression = function (fieldName, fieldValue) {
        if (typeof (fieldValue) == "string") {
            return fieldName + "==\"" + fieldValue + "\"";
        }
        else {
            var fieldValues = fieldValue;
            if (fieldValues.length > 0) {
                return fieldName + "==(\"" + fieldValues.join('","') + "\")";
            }
            else {
                return "";
            }
        }
    };
    ;
    ExpressionHelperUtilities.prototype.getExternalCollectionsExpression = function (externalCollections) {
        return this.getFilterExpression("@syscollection", externalCollections);
    };
    ExpressionHelperUtilities.prototype.getExternalSourcesExpression = function (externalSources) {
        return this.getFilterExpression("@syssource", externalSources);
    };
    ExpressionHelperUtilities.prototype.isDefined = function (property) {
        return typeof property !== "undefined";
    };
    return ExpressionHelperUtilities;
}());
exports.__esModule = true;
exports["default"] = ExpressionHelperUtilities;



//////////////////
// WEBPACK FOOTER
// ./Base/Rules/ExpressionHelperUtilities.ts
// module id = 11
// module chunks = 0